function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "System-Admin",
  transform: "translate(-817.000000, -516.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(813.500000, 519.500000) rotate(-180.000000) translate(-813.500000, -519.500000) translate(800.000000, 516.000000)"
}, React.createElement("path", {
  d: "M0.149960537,3.79351926 L4.90660353,6.95196166 C5.13812155,7.10927872 5.41173375,6.85515117 5.32754538,6.55261837 L4.87503289,4.9552452 L9.7053407,4.9552452 C9.8631939,4.9552452 10,4.81002946 10,4.61640847 L10,2.37766576 C10,2.19614608 9.87371744,2.03882903 9.7053407,2.03882903 L4.87503289,2.03882903 L5.32754538,0.441455858 C5.41173375,0.151024373 5.13812155,-0.103103177 4.90660353,0.0421125654 L0.149960537,3.21265628 C-0.0499868456,3.34577072 -0.0499868456,3.66040483 0.149960537,3.79351926 Z",
  id: "Path"
}))));

var SvgRightMove = function SvgRightMove(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRightMove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-move.fdb95843.svg";
export { ForwardRef as ReactComponent };